import { CSSProperties } from 'react';
import { SxProps } from '@mui/system';
import ColourPalette from './colorPalette';

const linkBase: CSSProperties & SxProps = {
  color: ColourPalette.palette.primary['50'],
  textDecoration: 'none',
  textUnderlineOffset: '4px',
  '&:hover': {
    textDecoration: 'underline #124EDE',
  },
};

export default linkBase;
